import { render, staticRenderFns } from "./PushRuleSetting.vue?vue&type=template&id=fd3d1ae2&"
import script from "./PushRuleSetting.vue?vue&type=script&lang=ts&"
export * from "./PushRuleSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports